import store from "@/store";
import router from "@/router";
// 面包屑导航创建父节点
function createParentSnapshot(route, detailRouteName) {
  if (!route || !route.name) return null
  return {
    name: route.name,
    path: route.path,
    fullPath: route.fullPath,
    title: route.meta && route.meta.title ? route.meta.title : '',
    detailRouteName
  }
}

export function updateBreadcrumbParent(to, from) {
  if (!to.meta || !to.meta.detailPage) return

  if (to.name === 'productDetails' || to.name === 'productReadonly') {
    if (from.name && from.name !== to.name && from.meta && from.meta.title) {
      store.commit('SET_BREADCRUMB_PARENT', createParentSnapshot(from, to.name))
      return
    }

    const sourcePath = to.query && to.query.breadcrumbFrom
    if (typeof sourcePath === 'string' && sourcePath.startsWith('/') && !sourcePath.startsWith('//')) {
      const sourceRoute = router.resolve(sourcePath).route
      if (sourceRoute.name && sourceRoute.name !== to.name && sourceRoute.meta && sourceRoute.meta.title) {
        store.commit('SET_BREADCRUMB_PARENT', createParentSnapshot(sourceRoute, to.name))
        return
      }
    }

    const currentParent = store.getters.breadcrumbParent
    if (from.name === to.name && currentParent && currentParent.detailRouteName === to.name) return
    store.commit('CLEAR_BREADCRUMB_PARENT')
    return
  }

  if (from.meta && from.meta.keepAlive) {
    store.commit('SET_BREADCRUMB_PARENT', createParentSnapshot(from, to.name))
    return
  }

  const sourcePath = to.query && to.query.breadcrumbFrom
  if (typeof sourcePath === 'string' && sourcePath.startsWith('/') && !sourcePath.startsWith('//')) {
    const sourceRoute = router.resolve(sourcePath).route
    if (sourceRoute.name && sourceRoute.name !== to.name && sourceRoute.meta && sourceRoute.meta.title) {
      store.commit('SET_BREADCRUMB_PARENT', createParentSnapshot(sourceRoute, to.name))
      return
    }
  }

  const currentParent = store.getters.breadcrumbParent
  if (from.meta && from.meta.detailPage && currentParent) {
    store.commit('SET_BREADCRUMB_PARENT', Object.assign({}, currentParent, {
      detailRouteName: to.name
    }))
    return
  }

  const parentName = to.meta.defaultParentName
  if (!parentName) {
    store.commit('CLEAR_BREADCRUMB_PARENT')
    return
  }

  const resolvedParent = router.resolve({name: parentName}).route
  store.commit('SET_BREADCRUMB_PARENT', createParentSnapshot(resolvedParent, to.name))
}



// WEBPACK FOOTER //
// ./src/utils/breadcrumb.js